// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w4JQ","footer":"styles_footer__3L0ZM"};